import { Component, OnInit, ViewChild } from "@angular/core";

import { MessageComponent } from "../../shared/component/message/message.component";

@Component({
  selector: "app-review-detail",
  styleUrls: ["./review-detail.component.css"],
  templateUrl: "./review-detail.component.html",
})
export class ReviewDetailComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;

  uploadPath: string = localStorage.getItem("apiIP") + "/upload";

  report: any;
  resume: any;

  constructor() {}

  ngOnInit() {
    this.getFromStorage();
  }

  getFromStorage() {
    this.report = JSON.parse(localStorage.getItem('report') || '{}');
    this.resume = JSON.parse(localStorage.getItem('resume') || '{}');

    if (!this.report) this.message.error("Erro ao gerar relatório");
    else this.message.success("Relatório gerado com sucesso");
  }

  getLogo = () => `/assets/layout/images/easycheck_logo_app.png`;
}


// getAllResume = () => new Object({
//   response_lenght: this.dataLenght,
//   full_data_balance: this.full_data_balance,
//   full_data_reviewed: this.full_data_reviewed,
//   full_data_order_count: this.full_data_order_count,
//   full_data_review_total: this.full_data_review_total,
// })


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/review/review-detail/review-detail.component.ts